import React, { useRef, useMemo } from "react";
import {
  GridColumnMenuFilter,
  GridColumnMenuProps,
} from "@progress/kendo-react-grid";
import { Row, Col, Modal } from "react-bootstrap";
import { Trans } from "react-i18next";
import {
  DateRangePicker,
  DateInput,
  DateRangePickerChangeEvent,
  SelectionRange,
} from "@progress/kendo-react-dateinputs";
import {
  Button,
  DropDownButton,
  DropDownButtonItemClickEvent,
} from "@progress/kendo-react-buttons";
import { t } from "i18next";
import {
  ComboBox,
  DropDownList,
  MultiSelect,
  MultiSelectChangeEvent,
} from "@progress/kendo-react-dropdowns";
import { Input, InputChangeEvent } from "@progress/kendo-react-inputs";
import { ODataProvider } from "../../contexts/ODataContext";
import SearchTags, { SearchTagHandle } from "../../components/SearchTags";
import config from "../../contexts/ConfigContext";
import { SvgIcon } from "@progress/kendo-react-common";
import * as svgIcons from "@progress/kendo-svg-icons";
import DataGridCustom, {
  ColumnCustomProps,
  DataGridHandle,
} from "../../components/DataGridCustom";
import { PermissionButton } from "../../components/PermissionButton";
import { Link, useNavigate } from "react-router-dom";
import { parseDate } from "@progress/kendo-intl";
import Moment from "react-moment";
import DocumentService from "../../services/DocumentService";
import { AnnotationService } from "../../services/Annotation";
import { CommonLibrary } from "../../contexts/CommonContext";
import {
  SearchService,
  BaseItemModel,
  SearchFilterResponseModel,
} from "../../services/SearchService";
import moment from "moment";
import SearchModal from "../../components/SearchModal";
import { useLoadingPanel } from "../../contexts/LoadingContext";
import { TabStrip, TabStripTab } from "@progress/kendo-react-layout";

// === FIX BUG #2: OData URLs defined OUTSIDE the component ===
// Previously they were `const xxxApiUrl = config.X + "..."` inside the function,
// so they were recalculated on every render. Now they are module-level constants.
const ENTITY_API_URL = config.API_URL + "/odata/ProjectEntities/";
const LABEL_API_URL = config.API_URL + "/odata/ProjectLabels/";
const SOURCE_API_URL = config.API_URL + "/odata/ProjectSources/";
const SOURCE_TYPE_API_URL = config.API_URL + "/odata/ProjectSourceTypes/";
const USER_API_URL = config.API_URL + "/odata/ProjectUsers/";
const COUNTRY_API_URL = config.API_URL + "/odata/Countries/";
const SEARCH_DOCUMENT_GRID_URL = config.API_LABELING_URL + "/odata/SearchResults";
const SEARCH_ANNOTATION_GRID_URL = config.API_LABELING_URL + "/odata/SearchAnnotationsResults";

function Search() {
  const navigate = useNavigate();
  var loadingPanel = useLoadingPanel();

  // === FIX BUG #3: services instantiated ONLY ONCE with useMemo ===
  // Previously they were `new XxxService()` on every render → cascade of re-renders
  // and potentially unstable usage of hooks (useAxios, useNotification).
  const comonLibrary = useMemo(() => new CommonLibrary(), []);
  const documentService = useMemo(() => new DocumentService(), []);
  const annotationService = useMemo(() => new AnnotationService(), []);
  const searchService = useMemo(() => new SearchService(), []);

  const [valueDateRange, setValueDateRange] = React.useState<SelectionRange>({
    start: new Date(new Date().setDate(new Date().getDate() - 30)),
    end: new Date(),
  });
  const [valueLastUpdateDateRange, setValueLastUpdateDateRange] = React.useState<SelectionRange>({
    start: null, 
    end: null 
  });
  const qaData = [
    { text: "Not Set (No Filter)", value: 0 },
    { text: "Reviewed", value: 1 },
    { text: "Not Reviewed", value: 2 },
  ];
  const flaggedData = [
    { text: "Not Set (No Filter)", value: 0 },
    { text: "Flagged", value: 1 },
    { text: "Not Flagged", value: 2 },
  ];
  const commentData = [
    { text: "Not Set (No Filter)", value: 0 },
    { text: "Has Comments", value: 1 },
    { text: "Has No Comments", value: 2 },
  ];
  const showSourceTypeFilter = comonLibrary.ShowSourceTypeFilter;
  const showCountryFilter = comonLibrary.ShowCountryFilter;
  const showUniqueIdFilter = comonLibrary.ShowUniqueIdFilter;
  const [statuses, setStatuses] = React.useState<any[]>([]);
  const [annotationStatuses, setAnnotationStatuses] = React.useState<any[]>([]);
  const [documentId, setDocumentId] = React.useState<string>("");
  const [uniqueId, setUniqueId] = React.useState<string>("");

  // NOTE: local URLs have been removed (they are now module-level constants above).

  const [valueEntity, setValueEntity] = React.useState<any[]>([]);
  const [, setFilterTypeEntity] = React.useState<number>(1);
  const [valueLabel, setValueLabel] = React.useState<any[]>([]);
  const [, setFilterTypeLabel] = React.useState<number>(1);
  const [valueUser, setValueUser] = React.useState<any[]>([]);
  const [, setFilterTypeUser] = React.useState<number>(1);
  const [valueSource, setValueSource] = React.useState<any[]>([]);
  const [, setFilterTypeSource] = React.useState<number>(1);
  const [valueSourceType, setValueSourceType] = React.useState<any[]>([]);
  const [, setFilterTypeSourceType] = React.useState<number>(1);
  const [, setFilterTypeCountry] = React.useState<number>(1);
  const [valueCountry, setValueCountry] = React.useState<any[]>([]);
  const [valueStatus, setValueStatus] = React.useState<any[]>([]);
  const [selectedAnnotationStatus, setSelectedAnnotationStatus] =
    React.useState<any[]>([]);
  const [selectedQAValue, setSelectedQAValue] = React.useState<any>(null);
  const [selectedFlaggedValue, setSelectedFlaggedValue] = React.useState<any>(null);
  const [selectedCommentsValue, setSelectedCommentsValue] = React.useState<any>(null);
  const dataGridRef = useRef<DataGridHandle>(null);
  const [valueSearch, setValueSearch] = React.useState<BaseItemModel>({
    Id: 0,
    Description: "",
  });
  const [, setIsOpen] = React.useState(false); // State to control dropdown visibility
  const entityDropDownRef = useRef<SearchTagHandle>(null);
  const labelDropDownRef = useRef<SearchTagHandle>(null);
  const userDropDownRef = useRef<SearchTagHandle>(null);
  const sourceDropDownRef = useRef<SearchTagHandle>(null);
  const sourceTypeDropDownRef = useRef<SearchTagHandle>(null);
  const countryDropDownRef = useRef<SearchTagHandle>(null);
  const [dataSearch, setDataSearch] = React.useState<BaseItemModel[]>([]);
  const [modalVisible, setModalVisible] = React.useState(false);
  const [searchOperation, setSearchOperation] = React.useState<string>("");
  const [modalTitle, setModalTitle] = React.useState<string>("");
  const [show, setShow] = React.useState(false);
  const [enableBrowseResults, setEnableBrowseResults] = React.useState(false);
  const [toggleAnnotationsSearchResultsView, setToggleAnnotationsSearchResultsView] = React.useState(false);

  // === FIX BUG #2 (parte finale): gridUrl memoizzato ===
  // Identità stabile della prop baseUrl: cambia SOLO quando cambia il toggle.
  const gridUrl = useMemo(
    () => (toggleAnnotationsSearchResultsView ? SEARCH_ANNOTATION_GRID_URL : SEARCH_DOCUMENT_GRID_URL),
    [toggleAnnotationsSearchResultsView]
  );

  const getCurrentFilters = async (
    statuses: any[],
    annotationStatuses: any[]
  ) => {
    const filters = await searchService.GetCurrentFilters();
    //After getting the filters, apply them to the dropdowns/inputs in the search seaction
    applyFilters(statuses, annotationStatuses, filters);
  };

  const applyFilters = async (
    statuses: any[],
    annotationStatuses: any[],
    filters: SearchFilterResponseModel
  ) => {
    // Set the filters to the dropdowns/inputs setting the selected values, updating the state
    
    setValueDateRange({
      start: filters.PublishStartDate? parseDate(filters.PublishStartDate): null,
      end: filters.PublishEndDate ? parseDate(filters.PublishEndDate): null,
    });

    setSelectedAnnotationStatus(
      annotationStatuses.filter((x) =>
        filters.AnnotationStatus.some((filter) => filter.Id === x.Id)
      )
    );
    setValueStatus(
      statuses.filter((x) =>
        filters.DocumentStatus.some((filter) => filter.Id === x.Id)
      )
    );
    entityDropDownRef?.current?.setSelectedValue(
      filters.Entities.map((item) => ({
        EntityId: item.Id,
        Description: item.Description,
      }))
    );
    setValueEntity(
      filters.Entities.map((item) => ({
        EntityId: item.Id,
        Description: item.Description,
      }))
    );
    labelDropDownRef?.current?.setSelectedValue(
      filters.Labels.map((item) => ({
        LabelId: item.Id,
        Description: item.Description,
      }))
    );
    setValueLabel(
      filters.Labels.map((item) => ({
        LabelId: item.Id,
        Description: item.Description,
      }))
    );
    userDropDownRef?.current?.setSelectedValue(
      filters.Users.map((item) => ({
        UserId: item.Id,
        Description: item.Description,
      }))
    );
    setValueUser(
      filters.Users.map((item) => ({
        UserId: item.Id,
        Description: item.Description,
      }))
    );
    sourceDropDownRef?.current?.setSelectedValue(
      filters.Sources.map((item) => ({
        SourceId: item.Id,
        Description: item.Description,
      }))
    );
    setValueSource(
      filters.Sources.map((item) => ({
        SourceId: item.Id,
        Description: item.Description,
      }))
    );
    sourceTypeDropDownRef?.current?.setSelectedValue(
      filters.SourceTypes.map((item) => ({
        SourceTypeId: item.Id,
        Description: item.Description,
      }))
    );
    setValueSourceType(
      filters.SourceTypes.map((item) => ({
        SourceTypeId: item.Id,
        Description: item.Description,
      }))
    );
    countryDropDownRef?.current?.setSelectedValue(
      filters.Countries.map((item) => ({
        CountryId: item.Id,
        Description: item.Description,
      }))
    );
    setValueCountry(
      filters.Countries.map((item) => ({
        CountryId: item.Id,
        Description: item.Description,
      }))
    );

    setSelectedQAValue(qaData.find((x) => x.value === filters.QAStatus));
    setSelectedFlaggedValue(flaggedData.find((x) => x.value === filters.FlaggedStatus));
    setSelectedCommentsValue(commentData.find((x) => x.value === filters.CommentStatus));
    setDocumentId(filters.DocumentId);
    setUniqueId(filters.UniqueId);

    setValueLastUpdateDateRange({
      start: filters.LastUpdateStartDate
        ? parseDate(filters.LastUpdateStartDate)
        : null,
      end: filters.LastUpdateEndDate
        ? parseDate(filters.LastUpdateEndDate)
        : null,
    });
  };

  const fetchUserSearches = async (setDefaultSearch?: boolean) => {
    const searches = await searchService.GetUserSearches();
    setDataSearch(searches);

    // Set default search(Current filters)
    if (setDefaultSearch) {
      setCurrentSeach(searches);
    }
  };

  const setCurrentSeach = async (searches: BaseItemModel[]) => {
    setValueSearch(
      searches.find((x) => x.Description === "My Last Search") ?? {
        Id: 0,
        Description: "",
      }
    );
  };

  // Clear all filters
  const clearFilters = () => {
    setSelectedAnnotationStatus([]);
    setValueStatus([]);
    setValueDateRange({ start: valueDateRange.start, end: valueDateRange.end });
    setValueLastUpdateDateRange({ start: null, end: null });
    entityDropDownRef?.current?.setSelectedValue([]);

    labelDropDownRef?.current?.setSelectedValue([]);

    userDropDownRef?.current?.setSelectedValue([]);

    sourceDropDownRef?.current?.setSelectedValue([]);

    countryDropDownRef?.current?.setSelectedValue([]);

    sourceTypeDropDownRef?.current?.setSelectedValue([]);
    setSelectedQAValue(0);
    setSelectedFlaggedValue(0);
    setSelectedCommentsValue(0);
    setDocumentId("");
    setUniqueId("");
  };

  // Handle the change of the date range
  const handleDateChange = (
    event: DateRangePickerChangeEvent,
    key: 'publishDate' | 'lastUpdateDate'
  ) => {
    if (key === 'publishDate') {
      setValueDateRange(event.value);
    } else {
      setValueLastUpdateDateRange(event.value);
    }
  };

  const PublishStartDateInput = (props: any) => {
    return (
      <label style={{ textAlign: "center" }}>
        <DateInput
          {...props}
          label={undefined}
          placeholder={t("general.start")}
          value={props.start}
        />
      </label>
    );
  };

  const PublishEndDateInput = (props: any) => {
    return (
      <label style={{ textAlign: "center" }}>
        <DateInput
          {...props}
          label={undefined}
          placeholder={t("general.end")}
          value={props.end}
        />
      </label>
    );
  };

  
  const handleFilterTypeEntityChange = (filterType: number) => {
    setFilterTypeEntity(filterType);
  };

  // Handle the change of the entity filter
  const handleValueEntityChange = (event: MultiSelectChangeEvent) => {
    setValueEntity(event.target.value);
  };

  const handleFilterTypeLabelChange = (filterType: number) => {
    setFilterTypeLabel(filterType);
  };
  // Handle the change of the label filter
  const handleValueLabelChange = (event: MultiSelectChangeEvent) => {
    setValueLabel(event.target.value);
  };

  const handleFilterTypeSourceChange = (filterType: number) => {
    setFilterTypeSource(filterType);
  };
  // Handle the change of the source filter
  const handleValueSourceChange = (event: MultiSelectChangeEvent) => {
    setValueSource(event.target.value);
  };

  const handleFilterTypeSourceTypeChange = (filterType: number) => {
    setFilterTypeSourceType(filterType);
  };

  const handleValueSourceTypeChange = (event: MultiSelectChangeEvent) => {
    setValueSourceType(event.target.value);
  };

  const handleFilterTypeUserChange = (filterType: number) => {
    setFilterTypeUser(filterType);
  };
  // Handle the change of the user filter
  const handleValueUserChange = (event: MultiSelectChangeEvent) => {
    setValueUser(event.target.value);
  };

  const handleFilterTypeCountryChange = (filterType: number) => {
    setFilterTypeCountry(filterType);
  };
  // Handle the change of the country filter
  const handleValueCountryChange = (event: MultiSelectChangeEvent) => {
    setValueCountry(event.target.value);
  };

  // Handle the change of the document status filter
  const handleValueStatusChange = (event: any) => {
    setValueStatus([...event.value]);
  };
  // Handle the change of the annotation status filter
  const handleAnnotationStatusChange = (event: any) => {
    setSelectedAnnotationStatus([...event.value]);
  };

  // Define the column menu
  const ColumnMenu = (props: GridColumnMenuProps) => {
    return (
      <div>
        <GridColumnMenuFilter {...props} expanded={true} />
      </div>
    );
  };
  // Define the columns
  const commandCell = (props: any) => {
    const documentId = props.dataItem.Id;
    return (
      <td style={{ textAlign: "center" }}>
        <span className="button-grid">
          <PermissionButton code="menu_search" mode="edit">
            <Link
              to="/dashboard/labeling"
              state={{
                from: {
                  operation: "search",
                  documentId: documentId,
                },
              }}
              className="k-button k-button-sm k-button-outline k-button-outline-secondary k-rounded-sm"
              >
               <span title={t("dataLabeling.search.open")}>
                  <SvgIcon
                  icon={svgIcons.arrowRightIcon}
                  size="large"
                />
               </span>
            </Link>
          </PermissionButton>

          <PermissionButton code="menu_search" mode="edit">
            <Link
              to="/dashboard/labeling"
              state={{
                from: {
                  operation: "search",
                  documentId: documentId,
                  // batchId: props.dataItem.BatchId,
                  },
                }}
              onClick={() => {
                localStorage.setItem("documentId", documentId);
              }}
                target="_blank"
                className="k-button mx-2 k-button-sm k-button-outline k-button-outline-secondary k-rounded-sm"
            >               
              <span title={t("dataLabeling.search.openNewTab")}>
                <SvgIcon
                  icon={svgIcons.hyperlinkOpenIcon}
                  size="large"
                />
              </span>
            </Link>
          </PermissionButton>
        </span>
      </td>
    );
  };

  const customDateCell = (props: any) => {
    if (props.dataItem[props.field] !== "") {
      return (
        <td>
          <Moment format="YYYY/MM/DD">{props.dataItem[props.field]}</Moment>
        </td>
      );
    }
    return <td>{props.dataItem[props.field]}</td>;
  };

// Handle the change of the dropdown search 
  const handleSearchChange = async (e: any) => {
    setValueSearch(e.target.value);
    setIsOpen(false);
    if (e.target.value) {
      await searchService
        .GetSearch(e.target.value.Id)
        .then((response) => {
          applyFilters(statuses, annotationStatuses, response);
        })
        .catch((error) => {});
    }
  };

  //This function is used to handle the selected operation (Save, Save As, Rename, Remove)
  const handleSearchOperationChange = (e: DropDownButtonItemClickEvent) => {
    if (e.item.label === "Save") {
      setModalVisible(true);
      setSearchOperation("Save");
      setModalTitle(t("dataLabeling.search.saveSelectedSearch"));
    } else if (e.item.label === "Save As") {
      setModalVisible(true);
      setSearchOperation("New");
      setModalTitle(t("dataLabeling.search.addSearch"));
    } else if (e.item.label === "Rename") {
      setModalVisible(true);
      setSearchOperation("Rename");
      setModalTitle(t("dataLabeling.search.renameSearch"));
    } else {
      setShow(true);
    }
  };

  const itemRender = (props: { item: any; itemIndex: number }) => {
    let fileIcon = null;
    if (props.item.label === t("general.save")) {
      fileIcon = svgIcons.saveIcon;
    } else if (props.item.label === t("general.saveAs")) {
      fileIcon = svgIcons.fileAddIcon;
    } else if (props.item.label === t("general.rename")) {
      fileIcon = svgIcons.editToolsIcon;
    } else {
      fileIcon = svgIcons.trashIcon;
    }

    return (
      <div>
        {props.item.label && <SvgIcon icon={fileIcon} />}
        {` ${props.item.label}`}
      </div>
    );
  };

  //This function is used to handle the confirm of the modal
  const handleConfirm = () => {
    deleteSearch();
    setShow(false);
  };

//This function is used to delete the selected search
  const deleteSearch = () => {
    searchService
      .DeleteSearch(valueSearch?.Id)
      .then((response) => {
        fetchUserSearches(true);
      })
      .catch((error) => {
        console.error("Error deleting search: ", error);
      });
  };

  //This function is used to handle the search click event. It will call the search service to execute the search
  const handleSearch = async () => {
    loadingPanel.show("#root");
    await searchService
      .ExecuteSearch({
        Id: valueSearch?.Id ?? 0,
        DocumentId: documentId ?? "",
        UniqueId: uniqueId ?? "",
        Description: "",
        PublishStartDate: valueDateRange.start ? moment(valueDateRange.start).format("YYYY-MM-DD"): null,
        PublishEndDate: valueDateRange.end ? moment(valueDateRange.end).format("YYYY-MM-DD"): null,
        Sources: valueSource.map((x) => x.SourceId),
        Entities: valueEntity.map((x) => x.EntityId),
        SourceTypes: valueSourceType.map((x) => x.SourceTypeId),
        Labels: valueLabel.map((x) => x.LabelId),
        Users: valueUser.map((x) => x.UserId),
        Countries: valueCountry.map((x) => x.CountryId),
        DocumentStatus: valueStatus.map((x) => x.Id),
        AnnotationStatus: selectedAnnotationStatus.map((x) => x.Id),
        QAStatus: selectedQAValue?.value,
        FlaggedStatus: selectedFlaggedValue?.value,
        CommentStatus: selectedCommentsValue?.value,
        LastUpdateStartDate: valueLastUpdateDateRange.start
        ? moment(valueLastUpdateDateRange.start).format("YYYY-MM-DD")
        : null, 
        LastUpdateEndDate: valueLastUpdateDateRange.end
        ? moment(valueLastUpdateDateRange.end).format("YYYY-MM-DD")
        : null 
      })
      .then((response) => {
        //If the search has results, enable the browse results button
         searchService.GetCountResults().then((total) => {
          if (total > 0) {
            setEnableBrowseResults(true);
           
          }
          else {
            setEnableBrowseResults(false);
           }
         });
         loadingPanel.hide();
         
         dataGridRef.current?.refreshDataFromFirstPage();
      })
      .catch((error) => {
        loadingPanel.hide();
        console.error("Error searching: ", error);
      });
  };

  //This function is used to handle the search save event. 
  const handleSearchSave = async (name: string) => {
    // Save the new search
    if (searchOperation === "New") {
      await searchService
        .CreateSearch({
          Id: valueSearch?.Id ?? 0,
          DocumentId: documentId ?? "",
          UniqueId: uniqueId ?? "",
          Description: name,
          PublishStartDate: moment(valueDateRange.start).format("YYYY-MM-DD"),
          PublishEndDate: moment(valueDateRange.end).format("YYYY-MM-DD"),
          Sources: valueSource.map((x) => x.SourceId),
          Entities: valueEntity.map((x) => x.EntityId),
          SourceTypes: valueSourceType.map((x) => x.SourceTypeId),
          Labels: valueLabel.map((x) => x.LabelId),
          Users: valueUser.map((x) => x.UserId),
          Countries: valueCountry.map((x) => x.CountryId),
          DocumentStatus: valueStatus.map((x) => x.Id),
          AnnotationStatus: selectedAnnotationStatus.map((x) => x.Id),
          QAStatus: selectedQAValue?.value,
          FlaggedStatus: selectedFlaggedValue?.value,
          CommentStatus: selectedCommentsValue?.value,
          LastUpdateStartDate: valueLastUpdateDateRange.start
          ? moment(valueLastUpdateDateRange.start).format("YYYY-MM-DD")
          : null, 
          LastUpdateEndDate: valueLastUpdateDateRange.end
          ? moment(valueLastUpdateDateRange.end).format("YYYY-MM-DD")
          : null 
        })
        .then((response) => {
          if (response) {
            setModalVisible(false);
            fetchUserSearches();
            applyFilters(statuses, annotationStatuses, response);
            setValueSearch({ Id: response.Id, Description: name });
          }
        })
        .catch((error) => {
          console.error("Error searching: ", error);
        });
    }

    // Update the search
    else if (searchOperation === "Save") {
      await searchService
        .UpdateSearch({
          Id: valueSearch?.Id ?? 0,
          DocumentId: documentId ?? "",
          UniqueId: uniqueId ?? "",
          Description: name,
          PublishStartDate: valueDateRange.start ? moment(valueDateRange.start).format("YYYY-MM-DD") : null,
          PublishEndDate: valueDateRange.end ? moment(valueDateRange.end).format("YYYY-MM-DD"): null,
          Sources: valueSource.map((x) => x.SourceId),
          Entities: valueEntity.map((x) => x.EntityId),
          SourceTypes: valueSourceType.map((x) => x.SourceTypeId),
          Labels: valueLabel.map((x) => x.LabelId),
          Users: valueUser.map((x) => x.UserId),
          Countries: valueCountry.map((x) => x.CountryId),
          DocumentStatus: valueStatus.map((x) => x.Id),
          AnnotationStatus: selectedAnnotationStatus.map((x) => x.Id),
          QAStatus: selectedQAValue?.value,
          FlaggedStatus: selectedFlaggedValue?.value,
          CommentStatus: selectedCommentsValue?.value,
          LastUpdateStartDate: valueLastUpdateDateRange.start
          ? moment(valueLastUpdateDateRange.start).format("YYYY-MM-DD")
          : null, 
          LastUpdateEndDate: valueLastUpdateDateRange.end
          ? moment(valueLastUpdateDateRange.end).format("YYYY-MM-DD")
          : null 
        })
        .then((response) => {
          setModalVisible(false);
        })
        .catch((error) => {
          console.error("Error searching: ", error);
        });
    }
    // Rename the search
    else if (searchOperation === "Rename") {
      await searchService
        .RenameSearch(valueSearch?.Id ?? 0, name)
        .then((response) => {
          setModalVisible(false);
          fetchUserSearches();
          setValueSearch({ Id: valueSearch?.Id, Description: name });
        })
        .catch((error) => {
          console.error("Error searching: ", error);
        });
    }
  };
  const isDisbabled = valueSearch?.Description === "My Last Search";

  const handlBrowseResult = () => {
  
    navigate("/dashboard/labeling", { state:{
      from: {
        operation: "search",
        },
    } });
  };

  React.useEffect(() => {
    const fetchData = async () => {
      // Fetch the document statuses and annotation statuses
      const docStatuses = await documentService.GetDocumentStatus();
      setStatuses(docStatuses);
      const annotationStatuses =
        await annotationService.GetAnnotationStatuses();
      setAnnotationStatuses(annotationStatuses);
      // Fetch the user searches
      await fetchUserSearches(true);
      // Apply the current filters
      await getCurrentFilters(docStatuses, annotationStatuses);
    };
    fetchData();
  }, []);

  // === FIX BUG #1: memoized `columns` array ===
  // Before: `const columns = []; columns.push(...)` recreated a new array
  // on EVERY render → DataGridCustom received a new `Columns` prop
  // on every state change → potential re-initialization of the data source.
  // Now: the array is recalculated ONLY when the toggle changes.
  const columns = useMemo<ColumnCustomProps[]>(() => {
    const cols = [] as ColumnCustomProps[];
    cols.push({
      field: "DocumentId",
      title: t("dataLabeling.search.documentResults.documentId"),
      columnMenu: ColumnMenu,
      isExportable: true,
    });
    cols.push({
      field: "SourceName",
      title: t("dataLabeling.search.documentResults.source"),
      columnMenu: ColumnMenu,
      isExportable: true,
    });
    cols.push({
      field: "PublishDate",
      title: t("dataLabeling.search.documentResults.date"),
      columnMenu: ColumnMenu,
      filter: "date",
      cell: customDateCell,
      isExportable: true,
    });
    cols.push({
      field: "Status",
      title: t("dataLabeling.search.documentResults.status"),
      columnMenu: ColumnMenu,
      isExportable: true,
    });
    cols.push({
      field: "BatchName",
      title: t("dataLabeling.search.documentResults.batch"),
      columnMenu: ColumnMenu,
      isExportable: true,
    });

    // Add columns for Annotation View
    if (toggleAnnotationsSearchResultsView) {
      cols.push({
        field: "EntityName",
        title: t("dataLabeling.search.annotationResults.entity"),
        columnMenu: ColumnMenu,
        isExportable: true,
      });
      cols.push({
        field: "Label",
        title: t("dataLabeling.search.annotationResults.label"),
        columnMenu: ColumnMenu,
        isExportable: true,
      });
      cols.push({
        field: "AnnotationStatus",
        title: t("dataLabeling.search.annotationResults.annotationStatus"),
        columnMenu: ColumnMenu,
        isExportable: true,
      });
    }

    cols.push({
      field: "UserName",
      title: t("dataLabeling.search.documentResults.user"),
      columnMenu: ColumnMenu,
      isExportable: true,
    });

    if (toggleAnnotationsSearchResultsView) {
      cols.push({
        field: "LastUpdateDate",
        title: t("dataLabeling.search.annotationResults.lastUpdate"),
        columnMenu: ColumnMenu,
        filter: "date",
        cell: customDateCell,
        isExportable: true,
      });
    }

    cols.push({ cell: commandCell, width: toggleAnnotationsSearchResultsView ? "120px" : "200px", isExportable: false });

    return cols;
    // NOTE: ColumnMenu, commandCell and customDateCell are defined inside the
    // component but do not depend on changing state, so they are still
    // captured by reference. If in the future you move them outside the
    // component or wrap them in useCallback, the dependencies here will
    // remain correct.
  }, [toggleAnnotationsSearchResultsView]);

  React.useEffect(() => {
    if (enableBrowseResults) {
      dataGridRef.current?.refreshData();
    }
  }, [toggleAnnotationsSearchResultsView]);
  
  return (
    <div id="search">
      <div className="pt-4">
        <div className="tile-content">
          <h5 className="title">
            <Trans>dataLabeling.search.title</Trans>
          </h5>
          <Row className="pt-2">
            <Col sm={11} className="row">
              <Col sm={3}>
                <fieldset>
                  <div className="subtitle">
                    <Trans>dataLabeling.search.filters.yourSearches</Trans>
                  </div>
                  <div className="d-flex">
                    <ComboBox
                      data={dataSearch}
                      defaultValue={dataSearch[0]}
                      value={valueSearch}
                      dataItemKey="Id"
                      textField="Description"
                      allowCustom={true}
                      onChange={handleSearchChange}
                      placeholder="Select saved searches"
                    />
  
                    <DropDownButton
                      svgIcon={svgIcons.moreVerticalIcon}
                      items={[
                        { label: t("general.save"), disabled: isDisbabled },
                        { label: t("general.saveAs"), disabled: false },
                        { label:  t("general.rename"), disabled: isDisbabled },
                        { label:  t("general.remove"), disabled: isDisbabled },
                      ]}
                      itemRender={itemRender}
                      themeColor={"secondary"}
                      fillMode={"solid"}
                      onItemClick={(e: DropDownButtonItemClickEvent) =>
                        handleSearchOperationChange(e)
                      }
                    />
                  </div>
                </fieldset>
              </Col>
              <Col sm={3}>
                <fieldset>
                  <div className="subtitle">
                    {" "}
                    <Trans>dataLabeling.search.filters.publishDate</Trans>
                  </div>
                  <DateRangePicker
                    format={"dd-MMM-yyyy"}
                    startDateInput={(props) => (
                      <PublishStartDateInput {...props} {...valueDateRange} />
                    )}
                    endDateInput={(props) => (
                      <PublishEndDateInput {...props} {...valueDateRange} />
                    )}
                    onChange={e => handleDateChange(e, 'publishDate')}
                  />
                </fieldset>
              </Col>
              <Col sm={3}>
                <fieldset>
                  <div className="subtitle">
                    <Trans>dataLabeling.search.filters.lastUpdateDate</Trans>
                  </div>
                  <DateRangePicker
                    clearButton={true}
                    format={"dd-MMM-yyyy"}
                    startDateInput={(props) => (
                      <PublishStartDateInput {...props} {...valueLastUpdateDateRange} />
                    )}
                    endDateInput={(props) => (
                      <PublishEndDateInput {...props} {...valueLastUpdateDateRange} />
                    )}
                    onChange={e => handleDateChange(e, 'lastUpdateDate')}
                  />
                </fieldset>
              </Col>
              <PermissionButton code="search_view_all_userdata" mode="edit" visible={false}>
                <Col sm={2}>
                  <fieldset>
                    <ODataProvider
                      baseUrl={USER_API_URL}
                      loadingContent=".k-multiselect"
                    >
                      <SearchTags
                        KeyField={"UserId"}
                        Label={t("dataLabeling.search.filters.users")}
                        PageSize={60}
                        PlaceHolder={"Search users"}
                        TextField={"Username"}
                        ref={userDropDownRef}
                        enableFilter={false}
                        width={"100%"}
                        customedTags={true}
                        onFilterTypeChange={handleFilterTypeUserChange}
                        onSetValue={handleValueUserChange}
                      />
                    </ODataProvider>
                  </fieldset>
                </Col>
              </PermissionButton>
            </Col>
          </Row>
          <Row className="pt-2">
            <Col sm={12} className="row">
              <Col sm={2}>
                <fieldset>
                  <div className="subtitle">
                    <Trans>dataLabeling.search.filters.documentStatus</Trans>
                  </div>
                  <MultiSelect
                    data={statuses}
                    onChange={handleValueStatusChange}
                    value={valueStatus}
                    placeholder="Select ..."
                    textField="Description"
                    dataItemKey="Id"
                    tags={
                      valueStatus.length > 0
                        ? [
                            {
                              text: `${valueStatus.length} items`,
                              data: [...valueStatus],
                            },
                          ]
                        : []
                    }
                  />
                </fieldset>
              </Col>
              <Col sm={2}>
                <fieldset>
                  <div className="subtitle">
                    <Trans>dataLabeling.search.filters.annotationStatus</Trans>
                  </div>
                  <MultiSelect
                    data={annotationStatuses}
                    onChange={handleAnnotationStatusChange}
                    value={selectedAnnotationStatus}
                    placeholder="Select ..."
                    textField="Description"
                    dataItemKey="Id"
                    tags={
                      selectedAnnotationStatus.length > 0
                        ? [
                            {
                              text: `${selectedAnnotationStatus.length} items`,
                              data: [...selectedAnnotationStatus],
                            },
                          ]
                        : []
                    }
                  />
                </fieldset>
              </Col>
              <Col md={2}>
                <fieldset>
                  <ODataProvider
                    baseUrl={ENTITY_API_URL}
                    loadingContent=".k-multiselect"
                  >
                    <SearchTags
                      KeyField={"EntityId"}
                      Label={t("Entities")}
                      PageSize={60}
                      width={"100%"}
                      ref={entityDropDownRef}
                      enableFilter={false}
                      PlaceHolder={"Search elements"}
                      TextField={"Description"}
                      customedTags={true}
                      onFilterTypeChange={handleFilterTypeEntityChange}
                      onSetValue={handleValueEntityChange}
                    />
                  </ODataProvider>
                </fieldset>
              </Col>
              <Col md={2}>
                <fieldset>
                  <ODataProvider
                    baseUrl={LABEL_API_URL}
                    loadingContent=".k-multiselect"
                  >
                    <SearchTags
                      KeyField={"LabelId"}
                      Label={t("Labels")}
                      PageSize={60}
                      width={"100%"}
                      ref={labelDropDownRef}
                      enableFilter={false}
                      PlaceHolder={"Search elements"}
                      TextField={"Path"}
                      customedTags={true}
                      onFilterTypeChange={handleFilterTypeLabelChange}
                      onSetValue={handleValueLabelChange}
                    />
                  </ODataProvider>
                </fieldset>
              </Col>
              {showCountryFilter && (
                <Col sm={2}>
                  <fieldset>
                    <ODataProvider
                      baseUrl={COUNTRY_API_URL}
                      loadingContent=".k-multiselect"
                    >
                      <SearchTags
                        KeyField={"CountryId"}
                        Label={t("dataLabeling.search.filters.countries")}
                        PageSize={60}
                        PlaceHolder={"Search elements"}
                        width={"100%"}
                        ref={countryDropDownRef}
                        customedTags={true}
                        enableFilter={false}
                        TextField={"Description"}
                        onFilterTypeChange={handleFilterTypeCountryChange}
                        onSetValue={handleValueCountryChange}
                      />
                    </ODataProvider>
                  </fieldset>
                </Col>
              )}
              <Col sm={2}>
                <fieldset>
                  <ODataProvider
                    baseUrl={SOURCE_API_URL}
                    loadingContent=".k-multiselect"
                  >
                    <SearchTags
                      KeyField={"SourceId"}
                      Label={t("dataLabeling.search.filters.sources")}
                      PageSize={200}
                      PlaceHolder={"Search sources"}
                      width={"100%"}
                      ref={sourceDropDownRef}
                      customedTags={true}
                      enableFilter={false}
                      TextField={"SourceDescription"}
                      onFilterTypeChange={handleFilterTypeSourceChange}
                      onSetValue={handleValueSourceChange}
                    />
                  </ODataProvider>
                </fieldset>
              </Col>
            </Col>
          </Row>
          <Row className="pt-2 align-items-center">
            {showSourceTypeFilter && (
              <Col sm={2}>
                <fieldset>
                  <ODataProvider
                    baseUrl={SOURCE_TYPE_API_URL}
                    loadingContent=".k-multiselect"
                  >
                    <SearchTags
                      KeyField={"SourceTypeId"}
                      Label={t("dataLabeling.search.filters.channels")}
                      PageSize={60}
                      PlaceHolder={"Search channels"}
                      width={"100%"}
                      ref={sourceTypeDropDownRef}
                      customedTags={true}
                      enableFilter={false}
                      TextField={"Description"}
                      onFilterTypeChange={handleFilterTypeSourceTypeChange}
                      onSetValue={handleValueSourceTypeChange}
                    />
                  </ODataProvider>
                </fieldset>
              </Col>
            )}
            <Col sm={2}>
              <fieldset>
                <div className="subtitle">
                  <Trans>dataLabeling.search.filters.isFlagged</Trans>
                </div>
                <DropDownList
                  data={flaggedData}
                  textField="text"
                  dataItemKey="value"
                  onChange={(e) => setSelectedFlaggedValue(e.value)}
                  value={selectedFlaggedValue}
                  fillMode={"solid"}
                />
              </fieldset>
            </Col>
            <Col sm={2}>
              <fieldset>
                <div className="subtitle">
                  <Trans>dataLabeling.search.filters.hasComments</Trans>
                </div>
                <DropDownList
                  data={commentData}
                  textField="text"
                  dataItemKey="value"
                  onChange={(e) => setSelectedCommentsValue(e.value)}
                  value={selectedCommentsValue}
                  fillMode={"solid"}
                />
              </fieldset>
            </Col>
            <Col sm={2}>
              <fieldset>
                <div className="subtitle">
                  <Trans>dataLabeling.search.filters.QAFilter</Trans>
                </div>
                <DropDownList
                  data={qaData}
                  textField="text"
                  dataItemKey="value"
                  onChange={(e) => setSelectedQAValue(e.value)}
                  value={selectedQAValue}
                  fillMode={"solid"}
                />
              </fieldset>
            </Col>
            <Col md={2}>
              <fieldset>
                <div className="subtitle">Document Id</div>
                <Input
                  placeholder="Type Document Id"
                  onChange={(e: InputChangeEvent) => setDocumentId(e.value)}
                  value={documentId??""}
                />
              </fieldset>
            </Col>
            {showUniqueIdFilter && (
              <Col md={2}>
                <fieldset>
                  <div className="subtitle">Unique Id</div>
                  <Input
                    placeholder="Type Unique Id"
                    onChange={(e: InputChangeEvent) => setUniqueId(e.value)}
                    value={uniqueId??""}
                  />
                </fieldset>
              </Col>
              )
            }
          </Row>
          <Row>
            <Col className="d-flex justify-content-end mt-3">
              <div className="d-flex gap-2 k-buttons-end">
                  <Button themeColor="secondary" onClick={clearFilters}>
                    <SvgIcon
                      className="btn-icons"
                      icon={svgIcons.xIcon}
                      size="medium"
                    />
                    <Trans>general.clear</Trans>
                  </Button>
                  <Button themeColor="primary" onClick={handleSearch}>
                    <SvgIcon
                      className="btn-icons"
                      icon={svgIcons.searchIcon}
                      size="medium"
                    />
                    <Trans>general.search</Trans>
                  </Button>
              </div>
            </Col> 
          </Row>
        </div>
      </div>
      <div className="pt-4">
        <div className="tile-content">
          <Row>
            <Col sm={12}>
              <TabStrip
                selected={toggleAnnotationsSearchResultsView ? 1 : 0}
                onSelect={(e) => setToggleAnnotationsSearchResultsView(e.selected === 1)}
                className="custom-tabstrip"
              >
                <TabStripTab title={t("dataLabeling.dashboard.documentsNumberToolTip")} disabled={!enableBrowseResults} />
                <TabStripTab title={t("dataLabeling.search.documentResults.annotationsTab")} disabled={!enableBrowseResults} />
              </TabStrip>
              <ODataProvider
                baseUrl={gridUrl}
                loadingContent=".k-grid-content"
              >
                <DataGridCustom
                  ref={dataGridRef}
                  DataItemKey="LabelId"
                  Columns={columns}
                  autoBind={false}
                  ShowCustomButton={true}
                  CustomButtonLabel ="dataLabeling.search.browseResults"
                  onCustomButtonClick={handlBrowseResult}
                  enableCustomButton = {enableBrowseResults}
                />
              </ODataProvider>
            </Col>
          </Row>
        </div>
      </div>
      <Modal show={show} onHide={() => setShow(false)}>
        <Modal.Header closeButton>
          <Modal.Title>
            <Trans>general.titleRemoveMessage</Trans>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Trans>general.removeMessage</Trans>
          <p className="center">
            <b> {valueSearch?.Description}</b>
          </p>
        </Modal.Body>
        <Modal.Footer>
          <Button themeColor="secondary" onClick={() => setShow(false)}>
            <Trans>general.cancel</Trans>
          </Button>
          <Button themeColor="primary" onClick={handleConfirm}>
            <Trans>general.ok</Trans>
          </Button>
        </Modal.Footer>
      </Modal>
      {modalVisible && (
        <SearchModal
          onClose={() => setModalVisible(false)}
          onSave={(name) => handleSearchSave(name)}
          initialValue={
            searchOperation === "New" ? "" : valueSearch?.Description
          }
          isEditing={searchOperation === "Save" ? true : false}
          title={modalTitle}
        />
      )}
    </div>
  );
}

export default Search;